export default function getNextPageParam(lastPage: any) {
  if (!lastPage?.page || !lastPage?.totalPages) {
    return 1;
  }
  if (lastPage.page >= lastPage.totalPages) {
    return undefined;
  }
  return lastPage.page + 1;
}
